import type { ReactNode } from 'react';

/**
 * Shell layout for authenticated screens. Single-column mobile-first,
 * safe-area padding, max-width to keep tablet/desktop usable.
 */
export function Layout({
  title,
  children,
  trailing,
}: {
  /** Either a string (rendered as <h1>) or a ReactNode (rendered raw — used
   * for the car-as-character header on AskPage). */
  title?: string | ReactNode;
  children: ReactNode;
  trailing?: ReactNode;
}) {
  return (
    <div
      className="kol-grain font-kol relative min-h-screen bg-carnaf-paper text-carnaf-ink"
      style={{ paddingTop: 'var(--carnaf-safe-top)' }}
    >
      {title && (
        <header className="sticky top-0 z-10 bg-carnaf-paper/90 backdrop-blur border-b border-carnaf-line">
          <div className="mx-auto max-w-xl px-4 py-3 flex items-center justify-between gap-3">
            {typeof title === 'string' ? (
              <h1 className="font-kol-display text-[22px] font-medium text-carnaf-ink">{title}</h1>
            ) : (
              title
            )}
            {trailing}
          </div>
        </header>
      )}
      <main
        className="relative z-[1] mx-auto max-w-xl px-4 py-6"
        style={{ paddingBottom: 'calc(var(--carnaf-safe-bottom) + 24px)' }}
      >
        {children}
      </main>
    </div>
  );
}
